
// src/web/components/diary-forms-fields.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import {
  Button,
} from 'react-toolbox/lib/button'
import {
  List,
  ListItem,
  ListDivider,
  ListItemContent,
} from 'react-toolbox/lib/list'
import {
  DatePickerDialog
} from 'react-toolbox/lib/date_picker'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import DropDown from 'react-toolbox/lib/dropdown'
import TimePickerDialog from './time-picker-dialog.jsx'
import Input from 'react-toolbox/lib/input'
import fieldListItemTheme from './themes/field-list-item.css'
import reportedDatePickerTheme from './themes/reported-date-picker.css'
import scrollableDialog from './themes/scrollable-dialog.css'
import { translate } from 'react-i18next'
import moment from 'moment'
import FIELD_ICONS from '../../helpers/field-icons'

const locale = {
  months: moment.months(),
  monthsShort: moment.monthsShort(),
  weekdays: moment.weekdays(),
  weekdaysShort: moment.weekdaysShort(),
  weekdaysLetter: moment.weekdaysShort(),
}

@translate()
class DateFieldItem extends React.Component {
  state = { active: false }

  render() {
    const {
      t,
      field,
      index,
      error,
      onUpdateField,
    } = this.props

    return(
      <ListItem selectable leftIcon={FIELD_ICONS[field.type]} theme={fieldListItemTheme}
        className={error && 'error'}
        caption={field.name} legend={field.value && moment(field.value).format('YYYY-MM-DD') || field.required && t('label:値を入力してください')}
        onClick={()=> this.setState({ active: true })} >
        <DatePickerDialog active={this.state.active}
          theme={reportedDatePickerTheme}
          autoOk={true}
          okLabel={t('label:OK')}
          cancelLabel={t('label:取り消し')}
          locale={locale}
          value={field.value ? new Date(field.value) : new Date()}
          onEscKeyDown={()=> this.setState({ active: false })}
          onOverlayClick={()=> this.setState({ active: false })}
          onSelect={(date)=> {
            onUpdateField(index, date)
            this.setState({ active: false})
          }}
          onDismiss={()=> this.setState({ active: false })} />
      </ListItem>
    )
  }
}

@translate()
class TimeFieldItem extends React.Component {
  state = { active: false }

  render() {
    const {
      t,
      field,
      index,
      error,
      onUpdateField,
    } = this.props

    return (
      <ListItem selectable leftIcon={FIELD_ICONS[field.type]} theme={fieldListItemTheme}
        className={error && 'error'}
        caption={field.name} legend={field.value || field.required && t('label:値を入力してください')}
        onClick={()=> this.setState({ active: true })} >
        <TimePickerDialog active={this.state.active}
          value={field.value}
          okLabel={t('label:OK')}
          cancelLabel={t('label:取り消し')}
          onSelect={(time)=> {
            onUpdateField(index, time)
            this.setState({ active: false})
          }}
          onCancel={()=> this.setState({ active: false })} />
      </ListItem>
    )
  }
}

@translate()
class StringFieldItem extends React.Component {
  render() {
    const {
      t,
      field,
      index,
      error,
      onUpdateField,
    } = this.props

    return(
      <ListItem ripple={false} selectable leftIcon={FIELD_ICONS[field.type]} theme={fieldListItemTheme} className={"input" + (error && ' error' || '')}>
        <ListItemContent>
          <Input type={field.type == "string" ? 'text' : 'number'} step='any'
            theme={fieldListItemTheme}
            label={field.name + (error && ': ' + t('label:値を入力してください') || '')}
            value={field.value}
            error={error}
            hint={field.required && t('label:値を入力してください')}
            onChange={(value)=> onUpdateField(index, value)} />
        </ListItemContent>
      </ListItem>
    )
  }
}

@translate()
class TextFieldItem extends React.Component {
  adjustHeight = ()=> {
    const target = ReactDOM.findDOMNode(this.refs.textarea).getElementsByTagName('textarea')[0]
    let lineHeight = Number(target.getAttribute("rows"))
    while (target.scrollHeight > target.offsetHeight){
      lineHeight++
      target.setAttribute("rows", lineHeight)
    }
  }

  onChange = (value)=> {
    this.adjustHeight()
    this.props.onUpdateField(this.props.index, value)
  }

  render() {
    const {
      t,
      field,
      index,
      error,
      onUpdateField,
    } = this.props

    return(
      <ListItem ripple={false} selectable leftIcon={FIELD_ICONS[field.type]} theme={fieldListItemTheme} className={"input" + (error && ' error' || '')}>
        <ListItemContent>
          <Input type="text" ref='textarea' theme={fieldListItemTheme}
            multiline={true} rows={5}
            label={field.name + (error && ': ' + t('label:値を入力してください') || '')}
            hint={field.required && t('label:値を入力してください')}
            error={error}
            value={field.value}
            onFocus={this.adjustHeight}
            onChange={this.onChange} />
        </ListItemContent>
      </ListItem>
    )
  }
}

@translate()
class DropDownFieldItem extends React.Component {
  state = { active: false }

  render() {
    const {
      t,
      field,
      index,
      error,
      onUpdateField,
    } = this.props

    return(
      <ListItem selectable leftIcon={FIELD_ICONS[field.type]} theme={fieldListItemTheme}
        className={error && 'error'}
        caption={field.name} legend={field.value || field.required && t('label:値を入力してください')}
        onClick={()=> this.setState({ active: true })} >
        <Dialog active={this.state.active} theme={scrollableDialog}
          onEscKeyDown={()=> this.setState({ active: false })}
          onOverlayClick={()=> this.setState({ active: false })}
          actions={[{ label: t('label:取り消し'), onClick: ()=> this.setState({ active: false }) }]} >
          <List selectable ripple>
            {_.map(field.options, (item, i)=> 
              <ListItem key={i} caption={item} onClick={()=> {
                onUpdateField(index, item)
                this.setState({ active: false })
              }} />
            )}
          </List>
        </Dialog>
      </ListItem>
    )
  }
}

@translate()
class DiaryFormsFields extends React.Component {
  render() {
    const {
      t,
      fields,
      onUpdateField,
    } = this.props

    if (!fields || fields.length == 0)
      return null

    return (
      <List selectable ripple theme={fieldListItemTheme}>
        {_.map(fields, (field, i)=> 
          field.type == 'date'     && <DateFieldItem key={i} field={field} error={fields[`${i}.valueError`]} index={i} onUpdateField={onUpdateField} /> ||
          field.type == 'time'     && <TimeFieldItem key={i} field={field} error={fields[`${i}.valueError`]} index={i} onUpdateField={onUpdateField} /> ||
          field.type == 'text'     && <TextFieldItem key={i} field={field} error={fields[`${i}.valueError`]} index={i} onUpdateField={onUpdateField} /> ||
          field.type == 'string'   && <StringFieldItem key={i} field={field} error={fields[`${i}.valueError`]} index={i} onUpdateField={onUpdateField} /> ||
          field.type == 'numeric'  && <StringFieldItem key={i} field={field} error={fields[`${i}.valueError`]} index={i} onUpdateField={onUpdateField} /> ||
          field.type == 'dropdown' && <DropDownFieldItem key={i} field={field} error={fields[`${i}.valueError`]} index={i} onUpdateField={onUpdateField} />
        )}
      </List>
    )
  }
}

export default DiaryFormsFields



// WEBPACK FOOTER //
// ./src/web/components/diary-forms-fields.jsx